import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { validatenull as _validatenull } from "@/util/validate";
import config from "./config.js";
export default {
  name: "sidebarItem",
  data: function data() {
    return {
      config: config
    };
  },
  props: {
    menu: {
      type: Array
    },
    screen: {
      type: Number
    },
    first: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    collapse: {
      type: Boolean
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapGetters(["roles"])), {}, {
    labelKey: function labelKey() {
      return this.props.label || this.config.propsDefault.label;
    },
    pathKey: function pathKey() {
      return this.props.path || this.config.propsDefault.path;
    },
    iconKey: function iconKey() {
      return this.props.icon || this.config.propsDefault.icon;
    },
    childrenKey: function childrenKey() {
      return this.props.children || this.config.propsDefault.children;
    },
    nowTagValue: function nowTagValue() {
      return this.$router.$avueRouter.getValue(this.$route);
    }
  }),
  methods: {
    generateTitle: function generateTitle(item) {
      return this.$router.$avueRouter.generateTitle(item[this.labelKey], (item.meta || {}).i18n);
    },
    vaildAvtive: function vaildAvtive(item) {
      var _this = this;

      var groupFlag = (item["group"] || []).some(function (ele) {
        return _this.$route.path.includes(ele);
      });
      return this.nowTagValue === item[this.pathKey] || groupFlag;
    },
    vaildRoles: function vaildRoles(item) {
      item.meta = item.meta || {};
      return item.meta.roles ? item.meta.roles.includes(this.roles) : true;
    },
    validatenull: function validatenull(val) {
      return _validatenull(val);
    },
    open: function open(item) {
      if (this.screen <= 1) this.$store.commit("SET_COLLAPSE");
      this.$router.$avueRouter.group = item.group;
      this.$router.$avueRouter.meta = item.meta;
      this.$router.push({
        path: this.$router.$avueRouter.getPath({
          name: item[this.labelKey],
          src: item[this.pathKey]
        }, item.meta),
        query: item.query
      });
    }
  }
};